import { Link } from "react-router-dom";
import { latestArticles } from "@/mocks/home";

export default function ArticlePreview() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              潮流解读
            </h2>
            <p className="text-sm text-foreground-600">
              最新穿搭指南与趋势深度解析
            </p>
          </div>
          <Link
            to="/articles"
            className="hidden md:flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            所有文章
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group cursor-pointer"
            >
              <div className="relative rounded-lg overflow-hidden aspect-[16/10] mb-4">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-accent-500/90 text-background-50 rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 mb-2 text-xs text-foreground-500">
                <span>{article.date}</span>
                <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                <span>{article.readTime}阅读</span>
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                {article.title}
              </h3>
              <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                {article.excerpt}
              </p>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center md:hidden">
          <Link
            to="/articles"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 cursor-pointer whitespace-nowrap"
          >
            查看所有文章
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}